//(function ($) {
(function ($, window, document) {
//  'use strict';

  // scripts para a secao de portal
  // onde o usuario ainda esta no processo conversao
  Drupal.behaviors.jsportal = function (context) {
    //
    // helpers
    // variaveis comuns no projeto

    var sw = document.body.clientWidth,
        sh = document.body.clientHeight; // scrips initials BradFrost

    var windowHeight = window.innerHeight,
        bodyHeight   = document.body.offsetHeight; // http://blog.rodneyrehm.de/archives/34-iOS7-Mobile-Safari-And-Viewport-Units.html

    var d = new Date(),
        n = d.getFullYear(); // data ano

    var pathname = window.location.pathname, // Returns path only
        url      = window.location.href; // Returns full URL

    var colMd, rwdMobile, rwdDesktop;
    colMd          = 992; // middle media query
    rwdMobile      = sw <= colMd;
    rwdDesktop     = sw > colMd;

    // https://github.com/rodneyrehm/viewport-units-buggyfill
//    window.viewportUnitsBuggyfill.init();

    // pegar o total de width de um array
    function getTotalWidth(target){
      var items = document.querySelectorAll(target);
      var total = null;

      items.forEach(function(item){
        total += item.clientWidth;
      });

      return total;
    }


    //
    // not-front
    //

    // botao de navegacao responsivo
    // aciona todo o topo escondido
    $('#btn-rwd-navigation').click(function(){
      $(this).toggleClass('active');
      $(this).parent().toggleClass('open');
      $('body').toggleClass('blocked');
    });

    //
    // products - page
    // listagem de produtos nos cursos gratuitos
    var listFree, listFreeMicro, listFreeTags;
    // listFree = $('body').hasClass('section-cursos-gratis-certificados');
    listFree = $('body').hasClass('section-micro-cursos-gratuitos');
    listFreeMicro = $('body').hasClass('section-taxonomy');
    listFreeTags = $('body').hasClass('section-tags');

    if (listFree | listFreeMicro | listFreeTags) {
      $('article').addClass('teaser-container');
    }

    if (listFreeMicro | listFreeTags) {
      var alvoRec = $('.taxonomy-term-description');
      $('.main-content').prepend(alvoRec);
    }

    //
    // products - node
    // recortar as tags de assuntos e inserir no container de informacoes do curso
    var tagsProd = $('.terms-inline');
    $(".field-field-prcu-descricao").after(tagsProd);

    // criar uma container para os itens de informaçoes do curso
    aaa = $('<div class="container"></div>');
    $('.build-mode-full .nav-product, .build-mode-full .field-field-image-cache, .build-mode-full .product-image, .build-mode-full .product-info, .build-mode-full .product-body, .build-mode-full .group-prse-formato, .build-mode-full .field-field-prcu-descricao, .build-mode-full .field-field-prcu-video-destaque, .build-mode-full .terms-inline').wrapAll(aaa);

    // deslocar video para o mesmo field da imagem
    var fieldCapa = $('.field-field-image-cache');
    var fieldVideo = $('.field-field-prcu-video-destaque .field-items');

    fieldVideo.addClass('field-prcu-video');
    fieldCapa.prepend(fieldVideo);

    // inserir id na tabela de carga horaria
    $('.field-field-prcu-tabela').attr('id', 'table-product');

    // recortar controles tablesaw e colar na label da tabela
    var controlsTable = $('.tablesaw-bar');
    $('.field-field-prcu-tabela .field-label').append(controlsTable);

    //
    // cart
    var blockCupom;
    // juntar itens
    blockCupom = $('#coupon-txt, #uc-coupon-block-form');
    // inserir
    $('#cart-form-products').after(blockCupom);
    
    // btn submit suporte
    // eliminar clique duplo
    $('#node-form #edit-submit').on('click', function(e){
      $(this).hide();
    });

    // teacher
    // incluir title no bloco de header
    var titleTeacher = $('.main-header__title').html();
    $('.teacher__title').append(titleTeacher);
    $('.teacher-title-sub').append(titleTeacher);
    
    // teacher
    $('#show-curriculum').click(function(e){
      e.preventDefault();
      
      $(this).parent().toggleClass('active');
      
      if($(this).parent().hasClass('active')){
        $(this).html('Visualizar menos'); 
      } else {
        $(this).html('Visualizar mais'); 
      }
    });
    
    // teacher
//    var itemRecorteVTtxt = $('.vertical-tabs-list-group_perf_curso_proposto');
//    var itemRecorteVT = $('.vertical-tabs-group_perf_curso_proposto');
//    $('.vertical-tabs').before(itemRecorteVT);
//    itemRecorteVT.prepend(itemRecorteVTtxt);
    // teacher
    var itemRecorteVTtxt = $('.vertical-tabs-list-group_perf_inst_infos');
    var itemRecorteVT = $('.vertical-tabs-group_perf_inst_infos');
//    $('.vertical-tabs').before(itemRecorteVT);
    $('.group-perf-endereco').before(itemRecorteVT);
    itemRecorteVT.prepend(itemRecorteVTtxt);

    // modal
//    var myContent = document.getElementById('trigger-modal');
//
//    var myModal = new Modal({
//      content: myContent
//    });
//
//    var triggerButton = document.getElementById('trigger-btn');
//
//    triggerButton.addEventListener('click', function() {
//      myModal.open();
//    });

// rating
//    var formOption = $(".form-radios .option");
//    $(".form-radios").append(formOption);
//
//    var formRadio = $(".form-radios .form-radio");
//    formRadio.each(function(){
//      $(this).parent().before(this);
//    });



    //
    // front
    //

    // banner links de servicos
    // recortar bloco e inserir no visual-header
    if( rwdDesktop ) {
      var rgBanner, replaceRgBanner;
      rgBanner = $('.region-banner');
      replaceRgBanner = $('#visual-banner');

      replaceRgBanner.replaceWith(rgBanner);
    }

    // listagem de produtos
    // inserir categoria nas imgens dos produtos
//    $('.view-produto .views-field-name-1 a').addClass('product__area');
    $('.view-catalogo-grade .views-field-name-1 a').addClass('product__area');

    // listagem de produtos
    // inserir setas nos controles do carrossel
    var svgNext, svgPrev;
    svgNext = $('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501.5 501.5"><g><path fill="#ffffff" d="M199.33 410.622l-55.77-55.508L247.425 250.75 143.56 146.384l55.77-55.507L358.44 250.75z"/></g></svg>');
    svgPrev = $('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501.5 501.5"><g><path fill="#ffffff" d="M302.67 90.877l55.77 55.508L254.575 250.75 358.44 355.116l-55.77 55.506L143.56 250.75z"/></g></svg>');

    $('.views_slideshow_previous').prepend(svgPrev);
    $('.views_slideshow_next').prepend(svgNext);

    // faq e noticias
    $( '#block-block-11, #block-views-noticias-block_1' ).wrapAll( '<section class="container"></section>' );

    // banner
    var bannerBlock, bannerAction;
    bannerBlock = $('#block-views-banner-block_1');
    bannerAction = $('#banner .views-field-title');

    bannerAction.click(function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).closest('#banner').toggleClass('active');
    });

    // rdp
    // efeito sanfona nos menus
    if( sw <= colMd ) {
      var rdpBtInst, rdpBtserv;

      rdpBtInst = $('.block-menu-menu-footer-menu__title');
      rdpBtserv = $('.block-menu-menu-servicos__title');

      function acaoBt(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next().toggleClass('in');
      }

      rdpBtInst.click( acaoBt );
      rdpBtserv.click( acaoBt );
    }
  }; // fim scripts portal


  // scripts para secao de usuarios
  // Ada e AVA
  Drupal.behaviors.logeduser = function (context) {
    // scrips initials BradFrost
    var sw = document.body.clientWidth,
        sh = document.body.clientHeight;

    // data ano
    var d = new Date();
    var n = d.getFullYear();

    var pathname = window.location.pathname, // Returns path only
        url      = window.location.href, // Returns full URL
        colMd    = 992; // middle media query

    var container, envolver;
    container = '<section class="container"></section>';
    envolver = '<section class="envolver"></section>';


    $('.ava-back').before('<br>');

    // AdA
    // inserir .bt-chamada no btn
//    $( '.page-aluno-suporte a[href="/suporte/abrir-chamado"]' ).addClass( 'bt-chamada ');

    $(document).ready(function(){
      $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
        $(this).toggleClass('open');
      });
    });

    // AdA
    // fechar dropdowmn com clique fora da caixa
    $(document).click(function(e) {
      var target = e.target.parentNode;

      if (!$(target).is('.box-user, .user-open, .menu-user li') && !$(target).parents().is('.box-user, .user-open, menu-user li')) {
        $('.box-user').removeClass('active');
      }
    });

    // AdA
    // navegacao do usuario
    // btn do usuario, informacoes sobre a conta
    var btUser = $('.user-open');

    btUser.attr('href', '#');

    btUser.click(function(e) {
      e.preventDefault();
      $(this).parents('.box-user').toggleClass('active');
    });

    // AdA
    // pagina de selecionar videos
//    $('.view-selecionar-videos > .view-header, .view-selecionar-videos > .view-content, .view-selecionar-videos > .item-list').wrapAll(envolver);

    // AdA | rwd
    // navegacao menu principal

    var $btMenu;
    $btMenu = $('#btn-rwd-navigation-aluno');

    function menuprincipal() {
      $btMenu.click(function( e ) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).closest('html').find('.section-aluno, .header__main').toggleClass( 'rwd' );
      });
    }

    $(document).ready(function () {
      if(sw <= colMd) {
        menuprincipal();
      }
    });

    // AdA | rwd
    // accordeon/collapse, listagem de cursos
    if(sw <= colMd) {
      var $btAcc, $boxAcc, $idCursos, $controlsClick;

      $btAcc = $('.ancora-abrir');
      $boxAcc = $('.curso-infos');

      $btAcc.attr('aria-expanded', 'false');
      $boxAcc.removeClass('in');
      $boxAcc.css({ height: '0' });

      $btAcc.click(function(e){
        e.preventDefault();

        $idCursos = $(this).next().attr('id');
        $controlsClick = $(this).attr('aria-controls');

        $(this).attr('aria-expanded', 'true');

        if($controlsClick == $idCursos) {
          $(this).next().toggleClass('in');

          if($( this ).next().hasClass( 'in' ) ) {
            $( this ).attr( 'aria-expanded', 'true' );
            $( this ).next().css({ height: '100%' });
          } else {
            $( this ).attr( 'aria-expanded', 'false' );
            $( this ).next().css({ height: '0' });
          }
        }
      });
    } else {
      $('.curso-infos').addClass('in');
    }


    // AdA
    // transicao entre rwd e desktop
    $( window ).resize( function() {
      var sw = document.body.clientWidth,
          sh = document.body.clientHeight;

      var colMd = 992;

      $btMenu = $('.bt-menu');

      if(sw <= colMd) {
        menuprincipal();
      }

      // navegacao menu principal
      // elimminar efeito rwd quando girar tela
      if( sw > colMd ) {
        if( $('html').find('body').hasClass('rwd') ) {
          $('body, .section-sub').removeClass('rwd');
          $('bt-menu').removeClass('active' );
        }
      }

      // cursos
      // accordeon/collapse rwd
      if( sw >= colMd ) {
        var $boxAcc = $( '.curso-infos' );
        $( '.curso-infos' ).addClass( 'in' );
        $( '.curso-infos' ).css({ height: '100%' });
      }
		});
  }; // fim scripts usuarios


  Drupal.behaviors.externals = function (context) {
    // external links, alternative for targer _blank
    $( 'a[rel*=external]' ).click( function() {
      window.open( this.href );
      return false;
    });

//    $( 'a[href*="#"]' ).click( function() {
//      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname){
//        var $target = $(this.hash);
//        $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
//        if ($target.length) {
//          var targetOffset = $target.offset().top;
//          $('html, body').animate({scrollTop: targetOffset}, 2000 );
//          return false;
//        }
//      }
//    });
  }
//}(Zepto));
}(Zepto, this, this.document));


